'use client'

import Multilingual from '@/src/components/global/Multilingual'
import RichText from '@/src/components/global/editor/RichText'
import { cx } from '@/src/styles/stylebook'
import { useState } from 'react'

const PlaceFoldedContent = ({ contents }: { contents: any }) => {
  const [isOpen, setIsOpen] = useState(false)

  const handleOpen = () => {
    setIsOpen(!isOpen)
  }

  return (
    <>
      <div className="flex items-center justify-between md:hidden">
        <p className="h6 text-gray-40 bold mb-0">
          <Multilingual>찾아오시는 길</Multilingual>
        </p>
        <button className="h-8 w-8" onClick={handleOpen}>
          <span className="bg-gray-40 absolute top-1/2 left-1/2 h-[3px] w-[calc(var(--spacing)*5)] -translate-x-1/2 -translate-y-1/2"></span>
          <span
            className={cx(
              'bg-gray-40 absolute top-1/2 left-1/2 h-[3px] w-[calc(var(--spacing)*5)] -translate-x-1/2 -translate-y-1/2 transition-all duration-300 ease-in-out',
              isOpen ? 'rotate-0' : '-rotate-90'
            )}
          ></span>
        </button>
      </div>
      <div
        className={cx(
          'transition-all duration-600 ease-in-out md:max-h-[60vh] md:opacity-100!',
          isOpen ? 'opacity-100 max-md:max-h-[60vh]' : 'opacity-0 max-md:max-h-[0px]'
        )}
      >
        <RichText value={contents} />
      </div>
    </>
  )
}

export default PlaceFoldedContent
